export default __webpack_public_path__ + "static/media/warrior2.d4be732e.png";